import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
// import util from 'util';
import constClass from '../../Constants/Constants';
import moment from 'moment';
import { useHistory, useParams } from 'react-router';

const CustomerDetail = (props) => {
  const { id, siteId } = useParams();
  const [campaignData, setCampaignData] = useState(null);
  const [customerData, setCustomerData] = useState(null);
  const [couponData, setCouponData] = useState(null);
  const [ticketData, setTicketData] = useState(null);
  const history = useHistory();

  const refreshData = useCallback(async () => {
    const jwt = localStorage.getItem('jwt');
    try {
      const campaign_points = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/campaignpoints/${siteId}/${id}`, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      })).data;
      setCampaignData(campaign_points);
      const customer = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/customer/${siteId}/${id}`, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      })).data;
      setCustomerData(customer);
      const coupon = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/coupon/${siteId}`, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      })).data;
      setCouponData(coupon);
      const ticket = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/ticket/${siteId}`, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      })).data;
      setTicketData(ticket);
    } catch (err) {
      console.log(err);
    }
  }, [siteId, id]);

  useEffect(() => {
    refreshData();
  }, [refreshData]); //


  const renderCampaignList = () => {
    return (
      <div className="row mb-3 p-0">
        <div className="col-12 p-0">
          <table className="table table-bordered table-striped">
            <thead className={`table-info`}>
              <tr>
                <td className="text-center align-middle">
                  キャンペーンID
                </td>
                <td className="text-center align-middle">
                  キャンペーン名
                </td>
                <td className="text-center align-middle">
                  獲得ポイント
                </td>
              </tr>
            </thead>
            <tbody>
              {campaignData.sort((a, b) => a.campaign_id > b.campaign_id ? -1 : 1).map((data, idx) => (
                <tr key={data.campaign_id}>
                  {/* ID */}
                  <td className="text-center align-middle">
                    {data.campaign_id}
                  </td>
                  {/* キャンペーン名 */}
                  <td className="text-center align-middle">
                    {data.campaign_name}
                  </td>
                  {/* 獲得ポイント */}
                  <td className="text-center align-middle">
                    {data.sum_point}
                  </td>
                </tr>
              ))
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  const renderCouponList = () => {
    return (
      <div className="row mb-3 p-0">
        <div className="col-12 p-0">
          <table className="table table-bordered table-striped">
            <thead className={`table-info`}>
              <tr>
                <td className="text-center align-middle">
                  クーポンID
                </td>
                <td className="text-center align-middle">
                  クーポン名
                </td>
                <td className="text-center align-middle">
                  利用年月
                </td>
                <td className="text-center align-middle">
                  クーポンコード
                </td>
                <td className="text-center align-middle">
                  使用日時
                </td>
              </tr>
            </thead>
            <tbody>
              {customerData.m_coupon_codes.sort((a, b) => a.use_date > b.use_date ? -1 : 1).map((data, idx) => (
                <tr key={data.coupon_id + '_' + data.coupon_month}>
                  {/* ID */}
                  <td className="text-center align-middle">
                    {data.coupon_id}
                  </td>
                  {/* クーポン名 */}
                  <td className="text-center align-middle">
                    {couponData.find(c => c.coupon_id === data.coupon_id).coupon_name}
                  </td>
                  {/* 利用年月 */}
                  <td className="text-center align-middle">
                    {data.coupon_month}
                  </td>
                  {/* クーポンコード */}
                  <td className="text-center align-middle">
                    {data.coupon_code}
                  </td>
                  {/* 使用日時 */}
                  <td className="text-center align-middle">
                    {data.use_date ? moment(data.use_date).format("YYYY/MM/DD HH:mm:ss") : ''}
                  </td>
                </tr>
              ))
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  const renderTicketList = () => {
    return (
      <div className="row mb-3 p-0">
        <div className="col-12 p-0">
          <table className="table table-bordered table-striped">
            <thead className={`table-info`}>
              <tr>
                <td className="text-center align-middle">
                  チケットID
                </td>
                <td className="text-center align-middle">
                  チケット名
                </td>
                <td className="text-center align-middle">
                  利用年月
                </td>
                <td className="text-center align-middle">
                  使用日時
                </td>
              </tr>
            </thead>
            <tbody>
              {customerData.t_ticket_uses.sort((a, b) => a.use_date > b.use_date ? -1 : 1).map((data, idx) => (
                <tr key={data.ticket_id + '_' + data.ticket_month}>
                  {/* ID */}
                  <td className="text-center align-middle">
                    {data.ticket_id}
                  </td>
                  {/* チケット名 */}
                  <td className="text-center align-middle">
                    {ticketData.find(t => t.ticket_id === data.ticket_id) ? ticketData.find(t => t.ticket_id === data.ticket_id).ticket_name : ''}
                  </td>
                  {/* 利用年月 */}
                  <td className="text-center align-middle">
                    {data.ticket_month}
                  </td>
                  {/* 使用日時 */}
                  <td className="text-center align-middle">
                    {data.use_date ? moment(data.use_date).format("YYYY/MM/DD HH:mm:ss") : ''}
                  </td>
                </tr>
              ))
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  const renderPaymentHistory = () => {
    return (
      <div className="row mb-3 p-0">
        <div className="col-8 p-0">
          <table className="table table-bordered table-striped">
            <thead className={`table-info`}>
              <tr>
                <td className="text-center align-middle">
                  決済年月
                </td>
                <td className="text-center align-middle">
                  決済日時
                </td>
                <td className="text-center align-middle">
                  取引ID
                </td>
                <td className="text-center align-middle">
                  処理区分
                </td>
              </tr>
            </thead>
            <tbody>
              {customerData.t_payment_histories.sort((a, b) => a.transaction_date > b.transaction_date ? 1 : -1).map((data, idx) => (
                <tr key={data.history_no}>
                  {/* 決済年月 */}
                  <td className="text-center align-middle">
                    {data.month}
                  </td>
                  {/* 決済日時 */}
                  <td className="text-center align-middle">
                    {data.transaction_date ? moment(data.transaction_date).format("YYYY/MM/DD HH:mm:ss") : ''}
                  </td>
                  {/* 取引ID */}
                  <td className="text-center align-middle">
                    {data.transaction_id}
                  </td>
                  {/* 取引ID */}
                  <td className="text-center align-middle">
                    {constClass.JOB_CD_NAME[data.job_cd]}
                  </td>
                </tr>
              ))
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      {customerData &&
        <div className="row mx-0 my-2 px-1-env">
          <div className="col">
            <div className="row my-1">
              <div className="col-auto text-left">
                <button type="button"
                  className={`btn btn-secondary mx-1 w-100`}
                  onClick={() => history.goBack()}>
                  戻る
                </button>
              </div>
              <div className="col">
                <div className="row my-2">
                  <div className="col-3">
                    <div className="row h-100">
                      <div className="col-auto text-center align-self-center">
                        <span>お客様ID</span>
                      </div>
                      <div className="col text-left align-self-center">
                        {customerData.customer_id}
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="row h-100">
                      <div className="col-auto text-center align-self-center">
                        <span>LINE UID</span>
                      </div>
                      <div className="col text-left align-self-center">
                        {customerData.line_id}
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="row h-100">
                      <div className="col-auto text-center align-self-center">
                        <span>メールアドレス</span>
                      </div>
                      <div className="col text-left align-self-center">
                        {customerData.mail_address}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row my-2">
                  <div className="col-3">
                    <div className="row h-100">
                      <div className="col-auto text-center align-self-center">
                        <span>NR番号</span>
                      </div>
                      <div className="col text-left align-self-center">
                        {customerData.card_id}
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="row h-100">
                      <div className="col-auto text-center align-self-center">
                        <span>性別</span>
                      </div>
                      <div className="col text-left align-self-center">
                        {constClass.GENDER_NAME[customerData.gender]}
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="row h-100">
                      <div className="col-auto text-center align-self-center">
                        <span>生まれた年</span>
                      </div>
                      <div className="col text-left align-self-center">
                        {customerData.birth}
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="row h-100">
                      <div className="col-auto text-center align-self-center">
                        <span>郵便番号</span>
                      </div>
                      <div className="col text-left align-self-center">
                        {customerData.postal_code}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row my-2">
                  <div className="col-3">
                    <div className="row h-100">
                      <div className="col-auto text-center align-self-center">
                        <span>バス定期</span>
                      </div>
                      <div className="col text-left align-self-center">
                        {customerData.bus_ticket_flag === constClass.FLAG.ON ? '○' : '×'}
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="row h-100">
                      <div className="col-auto text-center align-self-center">
                        <span>電車定期</span>
                      </div>
                      <div className="col text-left align-self-center">
                        {customerData.train_ticket_flag === constClass.FLAG.ON ? '○' : '×'}
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="row h-100">
                      <div className="col-auto text-center align-self-center">
                        <span>登録日時</span>
                      </div>
                      <div className="col text-left align-self-center">
                        {moment(customerData.register_date).format("YYYY/MM/DD HH:mm:ss")}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {(customerData === null || couponData === null || ticketData === null) && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {(campaignData !== null) && (renderCampaignList())}
      {(customerData !== null && couponData !== null) && (renderCouponList())}
      {(customerData !== null && ticketData !== null) && (renderTicketList())}
      {(customerData !== null) && (renderPaymentHistory())}
    </div>
  )
}

export default CustomerDetail;